import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

import { colors } from "@/theme/tokens/colors";

export const UploadCloud = (props: SvgIconProps): JSX.Element => (
  <SvgIcon sx={{ width: "34px", height: "31px" }} {...props}>
    <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 21.8633C3.19102 20.6524 2 18.5903 2 16.25C2 12.7346 4.68726 9.84694 8.11961 9.52905C8.82172 5.2582 12.5304 2 17 2C21.4696 2 25.1783 5.2582 25.8804 9.52905C29.3127 9.84694 32 12.7346 32 16.25C32 18.5903 30.809 20.6524 29 21.8633M11 21.5L17 15.5M17 15.5L23 21.5M17 15.5V29"
        stroke={colors.brand.blue}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
